export enum layoutAreaTypes {
  Unlogged = 'UnloggedAreaLayout',
  User = 'UserAreaLayout',
  Admin = 'AdminAreaLayout',
}

export interface FooterLink {
  href: string;
  label: string;
  isVisible: boolean;
}
